export default __webpack_public_path__ + "static/media/mls.e465f370.svg";